module.exports = __webpack_public_path__ + "img/oxymeter_grey.39193641.svg";